import { useTranslation } from 'react-i18next';

import MenuItem from '@material-ui/core/MenuItem';
import EntityTranslationsForm from 'components/EntityTranslationsForm/EntityTranslationsForm';

import CustomInput, { Props as CustomInputProps } from '../../../../components/CustomInput/CustomInput';
import { FlexContainer } from './styled';

interface Props {
    baseInputProps: Omit<CustomInputProps, 'name'>;
    isLoading: boolean;
}

const Form = (props: Props) => {
    const { baseInputProps, isLoading } = props;

    const { data, handleAttributeChange, partialTranslationKey } = baseInputProps;

    const { t } = useTranslation();

    return (
        <>
            <CustomInput {...baseInputProps} name='code' />

            <CustomInput {...baseInputProps} name='description' />

            <FlexContainer>
                <CustomInput {...baseInputProps} name='isPlastic' select booleanValues>
                    <MenuItem value={'1'} >
                        {t('dialogs.material_details.is_plastic_yes')}
                    </MenuItem>
                    <MenuItem value={'0'} >
                        {t('dialogs.material_details.is_plastic_no')}
                    </MenuItem>
                </CustomInput>

                <CustomInput {...baseInputProps} name='isCompostable' select booleanValues>
                    <MenuItem value={'1'} >
                        {t('dialogs.material_details.is_compostable_yes')}
                    </MenuItem>
                    <MenuItem value={'0'} >
                        {t('dialogs.material_details.is_compostable_no')}
                    </MenuItem>
                </CustomInput>
            </FlexContainer>

            <EntityTranslationsForm
                data={data}
                handleAttributeChange={handleAttributeChange ?? ((name: string, value: any) => undefined)}
                partialTranslationKey={partialTranslationKey ?? ''}
                isLoading={isLoading}
                modelName={'material'}
            />

            {/*<CustomInput {...baseInputProps} name='co2' /> */}
        </>
    );
};

export default Form;
